export default __webpack_public_path__ + "static/media/Group607@2x.e155ea77.png";